
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import BlueStrip from "../BlueStrip/BlueStrip";
import LandingPageLeftIcon from '../../assets/LandingPageLeftIcon.png';
const Navbar = ({ children }) => {
  return (
    <div className="d-flex">
      <div className="left-panel" style={{ width: "280px" }}>
        <BlueStrip />
        <img
          src={LandingPageLeftIcon}
          alt="Landing Page Icon"
          style={{ width: "230px", height: '350px',marginTop:"-1050px" }}
        />
      </div>
      <div className="content-wrapper flex-grow-1">
        {children}
        {/* <footer className="footer mt-5">
          <div className="d-sm-flex justify-content-center justify-content-sm-between">
            <span className="text-muted">
              © 2025 <a href="https://skyjumpertrampolinepark.com/">SKYJUMPER</a>
            </span>
            <span className="text-muted">SKYJUMPER ❤️</span>
          </div>
        </footer> */}
      </div>
    </div>
  );
};

export default Navbar;
